import { ProjectId } from "@taskin-code/contracts";
import { createFileRoute } from "@tanstack/react-router";

import { HomeView } from "~/components/HomeView";

function FocusedProjectIndexRoute() {
  const { projectId } = Route.useParams();
  return <HomeView fixedProjectId={ProjectId.makeUnsafe(projectId)} />;
}

export const Route = createFileRoute("/_chat/projects/$projectId/")({
  component: FocusedProjectIndexRoute,
});
